import { getEmbedTokenTtlSeconds, isFabricEmbedMode } from '@/lib/fabricEmbedAuth'
import type { ApiService } from '@/service/api'

type ClientErrorReport = Parameters<ApiService['reportClientError']>[0]

/** Gathers the common diagnostic fields for a browser-side failure report. */
export function buildClientErrorReport(
  surface: ClientErrorReport['surface'],
  error: unknown,
  extra: { has_context_id: boolean; has_conversation_id?: boolean }
): ClientErrorReport {
  const status = (error as { response?: { status?: unknown } } | null)?.response?.status
  return {
    surface,
    error_name: error instanceof Error ? error.name : typeof error,
    error_message: error instanceof Error ? error.message : String(error),
    status: typeof status === 'number' ? status : undefined,
    embed: isFabricEmbedMode(),
    online: navigator.onLine,
    path: window.location.pathname,
    embed_token_ttl_s: getEmbedTokenTtlSeconds(),
    visibility: document.visibilityState,
    ...extra,
  }
}
